import React, { useEffect, useState } from "react";
import { Progress, Table } from "antd";
import { AppState } from "../../Store";
import {
  fetchBatches,
  fetchPallets,
  fetchProducers,
  fetchProducts,
} from "../../Store/Warehouse/actions";
import { connect } from "react-redux";
import { fetchContracts } from "../../Store/Contracts/actions";
import { Contract } from "../../Models/Contract";
import { use } from "i18next";
import contracts from "../../Store/Contracts/reducers";
import { queries } from "@testing-library/react";

// Sample data
const data = [
  {
    key: "1",
    title: "Order 1",
    productName: "Widget A",
    contractId: "12345",
    quantity: 100,
    fulfilledQty: 60,
    remainingQty: 40,
    invoices: [
      { key: "1-1", invoiceNumber: "INV001", fulfilledQty: 30 },
      { key: "1-2", invoiceNumber: "INV002", fulfilledQty: 30 },
    ],
  },
  {
    key: "2",
    title: "Order 2",
    productName: "Widget B",
    contractId: "67890",
    quantity: 50,
    fulfilledQty: 50,
    remainingQty: 0,
    invoices: [{ key: "2-1", invoiceNumber: "INV003", fulfilledQty: 50 }],
  },
];

// Columns for the main table
const columns = [
  { title: "Lepingu nr", dataIndex: "contractNumber", key: "contractNumber" },
  { title: "Tootenimi", dataIndex: "productName", key: "productName" },
  {
    title: "Hind",
    dataIndex: "price",
    key: "price",
    render: (price: number) => <span>{price.toFixed(2)}€/kg</span>,
  },
  {
    title: "Kommentaarid",
    dataIndex: "comments",
    key: "comments",
    render: (comments: string) => (
      <div style={{ maxWidth: 200 }}>{comments}</div>
    ),
  },
  {
    title: "Lepingu algus",
    dataIndex: "startDate",
    key: "startDate",
    render: (date: string) => <span>{RenderDate(date, 1)}</span>,
  },
  {
    title: "Lepingu lõpp",
    dataIndex: "endDate",
    key: "endDate",
    render: (date: string) => <span>{RenderDate(date, 1)}</span>,
  },
  {
    title: "Kogus",
    dataIndex: "quantity",
    key: "quantity",
    render: (qty: number) => <span>{qty.toFixed(2)}</span>,
  },
  {
    title: "Tarnitud",
    dataIndex: "fulfilledQty",
    key: "fulfilledQty",
    render: (qty: number) => <span>{qty.toFixed(2)}</span>,
  },
  {
    title: "Tarnitud %",
    dataIndex: "percent",
    key: "percent",
    render: (percent: number) => <Progress percent={percent} />,
  },
  {
    title: "Tarnida",
    dataIndex: "remainingQty",
    key: "remainingQty",
    render: (qty: number, row: TableRow) => <strong>{qty.toFixed(2)}</strong>,
  },
];

// Columns for the nested invoices table
const invoiceColumns = [
  { title: "Arve number", dataIndex: "invoiceNumber", key: "invoiceNumber" },
  { title: "Kogus", dataIndex: "quantity", key: "quantity" },
  {
    title: "Kuupäev",
    dataIndex: "date",
    key: "date",
    render: (date: string) => <span>{RenderDate(date, 1)}</span>,
  },
];

const RenderDate = (date: string, key: number) => {
  let d = new Date(date);
  return (
    <div key={key}>
      <div>
        {date
          ? d.toLocaleDateString("et-EE", {
              // you can use undefined as first argument
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
          : "-"}
      </div>
    </div>
  );
};

interface Props {
  contracts: Contract[];
  fetching: boolean;
  fetchContracts: () => void;
}

type Row = {
  fulfilledQty: number;
  remainingQty: number;
  percent: number;
};

type TableRow = Contract & Row;

const ContractsTable = (props: Props) => {
  const [data, setData] = useState<TableRow[]>([]);

  useEffect(() => {
    props.fetchContracts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const mapped = props.contracts.map((contract) => {
      const fulfilledQty = contract.invoices.reduce((sum, item) => {
        return sum + item.quantity;
      }, 0);
      return {
        ...contract,
        fulfilledQty,
        remainingQty: contract.quantity - fulfilledQty,
        percent: Math.round((fulfilledQty / contract.quantity) * 100),
      };
    });
    setData(mapped);
  }, [props.contracts]);

  return (
    <Table
      columns={columns}
      dataSource={data}
      expandable={{
        expandedRowRender: (record) => (
          <Table
            columns={invoiceColumns}
            dataSource={record.invoices}
            pagination={false}
            rowKey={"invoiceNumber"}
          />
        ),
        rowExpandable: (record) => record.invoices.length > 0,
      }}
      rowKey="id"
    />
  );
};

const mapStateToProps = (state: AppState) => ({
  contracts: state.contracts.contracts,
  fetching: state.contracts.fetchingContracts,
});

const mapDispatchToProps = {
  fetchContracts,
};
export default connect(mapStateToProps, mapDispatchToProps)(ContractsTable);
